module.exports = __webpack_public_path__ + "img/f0e4cb902d79a697ba4c512c7e5d8f30.png";